(function() {
    const tabBtns = document.querySelectorAll('.tab-btn');
    const tabContents = document.querySelectorAll('[data-tab-content]');

    let currentActiveTab = null;

    function showTab(tabId) {
        if (currentActiveTab === tabId) {
            return;
        }

        // Batch DOM operations using requestAnimationFrame
        requestAnimationFrame(() => {
            // Batch all DOM reads first
            const activeTabContent = document.getElementById(tabId);
            const visibleCards = activeTabContent ? activeTabContent.querySelectorAll('.news-card') : [];
            
            // Batch all DOM writes
            tabContents.forEach(content => {
                const isActive = content.id === tabId;
                content.setAttribute('data-active', isActive);
            });

            tabBtns.forEach(btn => {
                const isActive = btn.getAttribute('data-tab-target') === tabId;
                btn.setAttribute('data-active', isActive);
            });

            // Reset all cards in one batch
            document.querySelectorAll('.news-card').forEach(card => {
                card.style.cssText = 'opacity: 1; transform: none;';
            });

            // Prepare visible cards for animation in one batch
            visibleCards.forEach(card => {
                card.style.cssText = 'opacity: 0; transform: translateY(50px) scale(0.9); visibility: hidden;';
            });

            // Use Intersection Observer for better performance
            const observer = new IntersectionObserver((entries) => {
                // Process entries in batches to avoid blocking
                const processEntries = (startIndex = 0) => {
                    const batchSize = 3; // Process 3 entries at a time
                    const endIndex = Math.min(startIndex + batchSize, entries.length);
                    
                    for (let i = startIndex; i < endIndex; i++) {
                        const entry = entries[i];
                        if (entry.isIntersecting) {
                            entry.target.style.visibility = 'visible';
                            const delay = (i - startIndex) * 100; // Reduced delay for smoother animation
                            
                            setTimeout(() => {
                                requestAnimationFrame(() => {
                                    entry.target.style.cssText += 'transition: all 500ms cubic-bezier(0.175, 0.885, 0.32, 1.275); opacity: 1; transform: translateY(0) scale(1);';
                                });
                            }, delay);
                            observer.unobserve(entry.target);
                        }
                    }
                    
                    // Process remaining entries in next frame
                    if (endIndex < entries.length) {
                        requestAnimationFrame(() => processEntries(endIndex));
                    }
                };
                
                processEntries();
            }, {
                threshold: 0.1, // Reduced threshold for earlier triggering
                rootMargin: '50px'
            });

            visibleCards.forEach(card => {
                observer.observe(card);
            });

            currentActiveTab = tabId;
        });
    }

    // Use event delegation for better performance
    const tabContainer = document.querySelector('.tab-buttons-container') || document.body;
    tabContainer.addEventListener('click', function(e) {
        const btn = e.target.closest('.tab-btn');
        if (btn) {
            const target = btn.getAttribute('data-tab-target');
            if (target) {
                showTab(target);
            }
        }
    });

    // Initialize first tab
    if (tabBtns.length > 0) {
        // Defer initialization to avoid blocking initial render
        requestAnimationFrame(() => {
            showTab(tabBtns[0].getAttribute('data-tab-target'));
        });
    }
})();

window.goToPageAjax = function(page, category) {
    const contentContainer = document.getElementById(category + '-content');
    const paginationContainer = document.getElementById(category + '-pagination');

    if (!contentContainer) {
        console.error('Content container not found for category:', category);
        return;
    }

    if (!paginationContainer) {
        console.error('Pagination container not found for category:', category);
        return;
    }

    // Use more efficient loading indicator
    contentContainer.innerHTML =
        '<div class="flex justify-center items-center py-8"><div class="animate-spin rounded-full h-8 w-8 border-b-2 border-[#00344C]"></div></div>';

    const currentLocale = document.documentElement.lang || 'en';
    const ajaxUrl = `/${currentLocale}/news/ajax?page=${page}&category=${category}`;

    fetch(ajaxUrl, {
            method: 'GET',
            headers: {
                'X-Requested-With': 'XMLHttpRequest',
                'Accept': 'application/json'
            }
        })
        .then(response => {
            if (!response.ok) {
                throw new Error(`HTTP error! status: ${response.status}`);
            }
            return response.json();
        })
        .then(data => {
            if (!data.success) {
                throw new Error(data.message || 'Failed to load news');
            }

            requestAnimationFrame(() => {
                contentContainer.innerHTML = data.newsHtml;
                paginationContainer.innerHTML = data.paginationHtml;

                const newCards = contentContainer.querySelectorAll('.news-card');
                
                const animateCards = (startIndex = 0) => {
                    const batchSize = 4;
                    const endIndex = Math.min(startIndex + batchSize, newCards.length);
                    
                    for (let i = startIndex; i < endIndex; i++) {
                        const card = newCards[i];
                        card.style.cssText = 'opacity: 0; transform: translateY(50px) scale(0.9);';
                        
                        const delay = (i - startIndex) * 150;
                        setTimeout(() => {
                            requestAnimationFrame(() => {
                                card.style.cssText += 'transition: all 500ms cubic-bezier(0.175, 0.885, 0.32, 1.275); opacity: 1; transform: translateY(0) scale(1);';
                            });
                        }, delay);
                    }
                    
                    if (endIndex < newCards.length) {
                        requestAnimationFrame(() => animateCards(endIndex));
                    }
                };
                
                animateCards();
            });
        })
        .catch(error => {
            console.error('Error loading news:', error);
            contentContainer.innerHTML =
                '<div class="py-8 text-center text-red-600">Error loading news. Please try again.</div>';
        });
};
